<template>
  <div>
    <v-progress-linear v-if="cargando" indeterminate color="purple" class="mb-2" />

    <ag-grid-vue
      class="ag-theme-balham ag-grid-listado-sedes"
      colResizeDefault="shift"
      :animateRows="false"
      :floatingFilter="true"
      :alwaysShowVerticalScroll="true"
      :suppressPaginationPanel="true"
      :gridOptions="gridOptions"
      :defaultColDef="defaultColDef"
      :rowSelection="rowSelection"
      :pagination="pagination"
      :rowClassRules="rowClassRules"
      :columnDefs="columnDefs"
      :rowData="rowData"
      @grid-ready="onGridReady"
      @selection-changed="onSelectionChanged"
      @first-data-rendered="onFirstDataRendered">
    </ag-grid-vue>
  </div>
</template>
  
<script>
import listadoAgGridMixin from '../../mixins/listado-ag-grid.mixin';
import { cellRendererNumeroRegistro, cellRendererSiONo } from '../../utils/funciones';

export default {
  name: 'ListadoSedes',
  mixins: [listadoAgGridMixin],
  data() {
    return {
      columnDefs: [
        {
          headerName: 'N° REGISTRO',
          cellRenderer: cellRendererNumeroRegistro,
          filter: false,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: false,
          minWidth: 100,
          maxWidth: 100,
        },
        {
          headerName: 'NOMBRE',
          field: 'nombre',
          minWidth: 300,
        },
        {
          headerName: 'UNIDAD DE NEGOCIO',
          field: 'unidadNegocio.nombre',
          minWidth: 300,
          maxWidth: 300,
        },
        {
          headerName: 'SEDE TALENTO HUMANO',
          cellRenderer: (params) => {
            const sedeTalentoHumano = params.data.sedeTalentoHumano?.nombre;

            return sedeTalentoHumano || '-';
          },
          minWidth: 300,
          maxWidth: 300,
        },
        {
          headerName: 'ESTADO',
          cellRenderer: cellRendererSiONo('estado', 'ACTIVO', 'INACTIVO'),
          filter: false,
          minWidth: 200,
          maxWidth: 200,
        },
        {
          headerName: 'DIRECCIÓN',
          field: 'direccion',
          filter: false,
          minWidth: 500,
          maxWidth: 500,
        },
      ],
    };
  },
};
</script>
  
<style>
@import '~ag-grid-community/dist/styles/ag-grid.css';
@import '~ag-grid-community/dist/styles/ag-theme-balham.css';

.ag-grid-listado-sedes {
  height: calc(var(--vh, 1vh) * 100 - 14.5rem);
}
</style>
  